///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'

///////////////////////////////////////////////////////////////////////////////
// локальный словарь основных ошибок
///////////////////////////////////////////////////////////////////////////////
const errorsDic = {
	'person': {
		'required': 'person/error_required',
		'list': 'person/error_list',
		'max': 'person/error_max_length'
	},
	'payer': {
		'required': 'payer/error_required',
		'list': 'payer/error_list',
		'max': 'payer/error_max_length'
	}
}

///////////////////////////////////////////////////////////////////////////////
// функция: составляет список полей-массивов
///////////////////////////////////////////////////////////////////////////////
const arrayFields = (Data) => {
	// готовим ответ
	let _names = {}

	// теперь бежим по всем полям данного типа
	for (let _fieldName in Data) if (Data.hasOwnProperty(_fieldName))
	{
		// имя поля - элемент массива
		let _match = _fieldName.match(/^(\w+)\[(.*)$/i)
		// нет - пропустим
		if (!_match || !_match[1]) continue
		// иначе - запомним
		_names[String(_match[1])] = true
	}

	// вернем ответ
	return Object.keys(_names)
}

///////////////////////////////////////////////////////////////////////////////
// функция: возвращает значение поля с заданным наименованием
///////////////////////////////////////////////////////////////////////////////
const getFieldValue = (fieldName, Data) => {
	// бежим по всем полям
	for (let _fieldName in Data) if (Data.hasOwnProperty(_fieldName))
	{
		// если это не искомое поле
		if (_fieldName !== fieldName)
			// идем дальше
			continue
		else
			// нашли поле
			return Data[_fieldName].value
	}

	// не нашли
	return null
}

///////////////////////////////////////////////////////////////////////////////
// основные валидаторы
///////////////////////////////////////////////////////////////////////////////
// PERSON
const personValidators = {
	'low_name_russian': (value) => {
		if (value.length > 254) return 'person/error_lnr_max'
		else if (value.match(/(«|»)/g)) return 'person/error_lnr_quotes'
		else if (value.match(/(\\|\/)/g)) return 'person/error_lnr_slashes'
		else if (!/^[0-9а-яё\-",. ]*$/i.test(value)) return 'person/error_lnr_reg'
		return ''
	},
	'low_name_english': (value) => {
		if (value.length > 254) return 'person/error_lne_max'
		else if (value.match(/(«|»)/g)) return 'person/error_lne_quotes'
		else if (value.match(/(\\|\/)/g)) return 'person/error_lne_slashes'
		else if (!/^[0-9a-z\-",. ]*$/i.test(value)) return 'person/error_lne_reg'
		return ''
	},
	'inn_10': (value) => {
		if (value.length !== 10) return 'person/error_inn10'
		else if (!Helper.checkINN(value)) return 'person/error_inn10cc'
		return ''
	},
	'inn_12': (value) => {
		if (value.length !== 12) return 'person/error_inn12'
		else if (!Helper.checkINN(value)) return 'person/error_inn12cc'
		return ''
	},
	'kpp': (value) => {
		if (!/^\d{9}$/.test(value)) return 'person/error_kpp'
		return ''
	},
	'ogrn': (value) => {
		if (value.length !== 13) return 'person/error_ogrn'
		else if (!Helper.checkOGRN(value)) return 'person/error_ogrncc'
		return ''
	},
	'email': (value) => {
		if (!Helper.validateEmail(value)) return 'person/error_email'
		return ''
	},
	'phone': (value) => {
		let _val = String(value).replace(/_/g, '')
		if (_val.indexOf('(') > -1 || _val.indexOf(')') > -1)
		{
			_val = _val.replace(/\(/g, ' ').replace(/\)/g, ' ').replace(/-/g, '')
		}
		else
		{
			_val = _val.replace('-', ' ')
			_val = _val.replace('-', ' ')
			_val = _val.replace(/-/g, '')
		}
		let _clearVal = _val.replace(/ /g, '')

		let _test = /^\+\d+ ?\d+ ?\d+$/.test(_val) && _clearVal.length <= 15
		if (!_test) return 'person/error_phone'

		return ''
	},
	'address_russian': (value) => {
		if (value.length > 254) return 'person/error_ar_max'
		else if (!/^[A-Z \-\d]{4,16},.+/.test(value)) return 'person/error_ar_reg'
		return ''
	},
	'address_post_russian': (value) => {
		if (value.length > 254) return 'person/error_apr_max'
		else if (!/^[A-Z \-\d]{4,16},.+/.test(value)) return 'person/error_apr_reg'
		else if (!/[а-яё. ]{3,}$/i.test(value)) return 'person/error_apr_to'
		return ''
	},
	'phis_name_russian': (value) => {
		if (value.length > 64) return 'person/error_pnr_max'
		// eslint-disable-next-line
		else if (!/^([А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+|[А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+)$/.test(value))
			return 'person/error_pnr_reg'
		return ''
	},
	'phis_name_russian_plus': (value) => {
		if (value.length > 96) return 'person/error_pnr_max'
		// eslint-disable-next-line
		else if (!/^([А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+|[А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+)$/.test(value))
			return 'person/error_pnr_reg'
		return ''
	},
	'phis_name_english': (value) => {
		if (value.length > 64) return 'person/error_pne_max'
		// eslint-disable-next-line
		else if (!/^([A-Z]{1}[A-Za-z\-]+ [A-Z]{1} [A-Z]{1}[A-Za-z\-]+|[A-Z]{1}[A-Za-z\-]+ [A-Z]{1}[A-Za-z\-]+)$/.test(value)) return 'person/error_pne_reg'
		return ''
	},
	'phis_name_english_2': (value) => {
		if (value.length > 64) return 'person/error_pne2_max'
		// eslint-disable-next-line
		else if (!/^[A-Z]{1}[A-Za-z\-]+ [A-Z]{1}[A-Za-z\-]+$/.test(value)) return 'person/error_pne2_reg'
		return ''
	},
	'date': (value, format, fieldName) => {
		let _val = Helper.FormatDateTime(value, format)
		let _exp = '^' + format
			.replace('d', '\\d{2}')
			.replace('m', '\\d{2}')
			.replace('y', '\\d{2}')
			.replace('Y', '\\d{4}') + '$'
		let _reg = new RegExp(_exp)

		if (!_reg.test(_val)) return 'person/error_date'
		else
		{
			if (fieldName.indexOf('[birth_date]') > 0)
			{
				let _dt = Helper.FormatedStrDate2Date(value, format)
				let _years = Helper.calculateAge(_dt)
				if (_years >= 100) return 'person/too_high_age'
			}
		}

		return ''
	},
	'passport': (value) => {
		if (value.length > 254) return 'person/error_passport_max'
		// eslint-disable-next-line
		else if (!/^[0-9 a-zA-Z\-а-яёА-ЯЁ]+ выдан .{4,}, \d{2}\.\d{2}\.\d{4}$/.test(value)) return 'person/error_passport_reg'
		return ''
	},
	'zip': (value) => {
		// eslint-disable-next-line
		if (!/^[A-Z \-\d]{4,16}$/.test(value)) return 'person/error_zip'
		return ''
	},
	'text_english': (value) => {
		// eslint-disable-next-line
		if (!/^[A-Z]{1}[A-Za-z\- ,\.0-9\/]+/.test(value)) return 'person/error_te'
		return ''
	}
}

// PAYER
const payerValidators = {
	'low_name_russian': (value) => {
		if (value.length > 230) return 'payer/error_lnr_max'
		else if (!/[0-9а-яё\-"«»,. #№]/i.test(value)) return 'payer/error_lnr_reg'
		return ''
	},
	'inn_10': (value) => {
		if (value.length !== 10) return 'payer/error_inn10'
		else if (!Helper.checkINN(value)) return 'payer/error_inn10cc'
		return ''
	},
	'inn_12': (value) => {
		if (value.length !== 12) return 'person/error_inn12'
		else if (!Helper.checkINN(value)) return 'person/error_inn12cc'
		return ''
	},
	'inn': (value) => {
		if (value.length !== 10 && value.length !== 12) return 'payer/error_inn10cc'
		else if (!Helper.checkINN(value)) return 'payer/error_inn10cc'
		return ''
	},
	'kpp': (value) => {
		if (!/^\d{9}$/.test(value)) return 'payer/error_kpp'
		return ''
	},
	'ogrn': (value) => {
		if (value.length !== 13 && value.length !== 15) return 'payer/error_ogrn'
		else if (!Helper.checkOGRN(value)) return 'payer/error_ogrncc'
		return ''
	},
	'email': (value) => {
		if (!Helper.validateEmail(value)) return 'payer/error_email'
		return ''
	},
	'phone': (value) => {
		let _val = String(value).replace(/_/g, '')
		if (_val.indexOf('(') > -1 || _val.indexOf(')') > -1)
		{
			_val = _val.replace(/\(/g, ' ').replace(/\)/g, ' ').replace(/-/g, '')
		}
		else
		{
			_val = _val.replace('-', ' ')
			_val = _val.replace('-', ' ')
			_val = _val.replace(/-/g, '')
		}
		let _clearVal = _val.replace(/ /g, '')

		let _test = /^\+\d+ ?\d+ ?\d+$/.test(_val) && _clearVal.length <= 15
		if (!_test) return 'payer/error_phone'

		return ''
	},
	'address_russian': (value) => {
		if (value.length > 250) return 'payer/error_ar_max'
		else if (!/^[A-Z \-\d]{4,16},.+/.test(value)) return 'payer/error_ar_reg'
		return ''
	},
	'phis_name_russian': (value) => {
		if (value.length > 64) return 'payer/error_pnr_max'
		// eslint-disable-next-line
		else if (!/^([А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+|[А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+)$/.test(value))
			return 'payer/error_pnr_reg'
		return ''
	},
	'phis_name_russian_plus': (value) => {
		if (value.length > 96) return 'payer/error_pnrp_max'
		// eslint-disable-next-line
		else if (!/^[А-ЯЁа-яё ]+ ([А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+|[А-ЯЁ]{1}[А-ЯЁа-яё\-]+ [А-ЯЁ]{1}[А-ЯЁа-яё\-]+)$/.test(value))
			return 'payer/error_pnrp_reg'
		return ''
	},
	'text_russian': (value) => {
		if (!/^[А-ЯЁа-яё\- ,.0-9/#№]+/.test(value))
			return 'payer/error_tr'
		return ''
	},
	'bank_bic': (value) => {
		if (!Helper.checkBIC(value)) return 'payer/error_bic'
		return ''
	},
	'bank_account': (value, Data) => {
		let bic = getFieldValue('data[bic]', Data)
		// если БИКа еще нет - не проверяем
		if (!bic || !String(bic).trim().length) return ''
		// если БИК некорректен - не проверяем
		if (!Helper.checkBIC(bic)) return ''

		if (!Helper.checkKS(value, bic)) return 'payer/error_ks'
		return ''
	},
	'user_account': (value, Data) => {
		let bic = getFieldValue('data[bic]', Data)
		// если БИКа еще нет - не проверяем
		if (!bic || !String(bic).trim().length) return ''
		// если БИК некорректен - не проверяем
		if (!Helper.checkBIC(bic)) return ''

		if (!Helper.checkRS(value, bic)) return 'payer/error_rs'
		return ''
	}
}

///////////////////////////////////////////////////////////////////////////////
// общий валидатор
///////////////////////////////////////////////////////////////////////////////
const validators = {
	'person': personValidators,
	'payer': payerValidators
}

///////////////////////////////////////////////////////////////////////////////
// Валидатор полей формы в виде массива
///////////////////////////////////////////////////////////////////////////////
const validatorArray = (Data, crud) => {
	// это не ошибка в данном контексте
	if (!Data || !crud) return false

	// готовим ответ
	let _result = {}

	// получим все поля-массивы
	let _arrayFields = arrayFields(Data)
	// это не ошибка в данном контексте
	if (!_arrayFields || !_arrayFields.length) return false

	// теперь бежим по всем полям данного типа
	_arrayFields.forEach(arrayName => {
		// exp: arrayName = data
		// каждый раз бежим по всем полям формы - ищем поля данного массива
		for (let _fieldName in Data) if (Data.hasOwnProperty(_fieldName))
		{
			//-----------------------------------------------------------------
			// выявление - проверять поле или нет
			//-----------------------------------------------------------------
			// будем проверять только поля текущего массива полей
			// exp: _fieldName = data[ru_low][email]
			let _reg = new RegExp('^' + arrayName + '\\[\\w+\\](.*)$', 'i')
			if (!_reg.test(_fieldName)) continue

			// получим поле
			let _field = Data[_fieldName]

			// если уже установлена какая то ошибка
			if (_field['_errMsg']) continue

			// будем проверять только видимые поля
			if (!_field['_visible']) continue

			//-----------------------------------------------------------------
			// раз дошли до сих пор - поле нужно проверить
			//-----------------------------------------------------------------
			// 1. обязательное поле
			if (_field['required'] === true && (_field['value'] === undefined || _field['value'] === null || _field['value'] === ''))
			{
				// установим ошибку
				_result[_fieldName] = errorsDic[crud]['required']
				// перейдем к следующему полю
				continue
			}

			// 2. проверка списка
			if (_field['type'] === 'list' && _field['list'])
			{
				// если значение не из списка
				if (!Helper.valueInList(_field['value'], _field['list']))
				{
					// если при этом оно обязательно
					if (_field['required'] === true)
					{
						// установим ошибку
						_result[_fieldName] = errorsDic[crud]['list']
						// перейдем к следующему полю
						continue
					}
					// для необязательного поля может быть пустое значение - которое не в списке
				}
			}

			// 3. максимальное значение
			if ('max' in _field && _field['max'] > 0 && String(_field['value']).length > _field['max'])
			{
				// установим ошибку
				_result[_fieldName] = errorsDic[crud]['max'] + ' ' + _field['max']
				// перейдем к следующему полю
				continue
			}

			// 4. больше проверок нет кроме как по валидатору
			if (!_field['validator']) continue

			// получаем значение поля
			let _value = _field['value'] !== undefined && _field['value'] !== null && _field['value'] !== '' ? String(_field['value']) : null

			// если значение поля не задано - проверка валидатором не нужна
			// если поле обязательно к заполнению - оно бы уже попало в ошибки
			if (!_value) continue

			let _validator = validators[crud] ? validators[crud] : personValidators
			// проверим соответствующим валидатором
			if (_validator[_field['validator']])
			{
				let _err = ''
				if (_field['validator'] === 'date')
					_err = _validator[_field['validator']](_value, _field['format'], _fieldName)
				else if (_field['validator'] === 'bank_account' || _field['validator'] === 'user_account')
					_err = _validator[_field['validator']](_value, Data)
				else
					_err = _validator[_field['validator']](_value)

				if (_err) _result[_fieldName] = _err
			}

			//-----------------------------------------------------------------
		}
	})

	// вернем получившийся ответ
	return Object.keys(_result).length ? _result : false
}

///////////////////////////////////////////////////////////////////////////////
export default { validators, personValidators, validatorArray }
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/validators/array.js